import React from 'react'
import { Box, Typography, Alert, CircularProgress } from '@mui/material'
import { useAdminPageAccess } from '@hooks/useAdminPermissions'

interface AdminPageGateProps {
  permission: string
  title: string
  children: React.ReactNode
}

/**
 * Renders children when the current admin session holds the required permission.
 */
const AdminPageGate: React.FC<AdminPageGateProps> = ({ permission, title, children }) => {
  const { loading, fetchError, denied } = useAdminPageAccess(permission)

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    )
  }

  if (fetchError) {
    return (
      <Box>
        <Typography variant="h4" component="h1" gutterBottom>
          {title}
        </Typography>
        <Alert severity="error">Could not load your admin permissions. Try refreshing the page.</Alert>
      </Box>
    )
  }

  if (denied) {
    return (
      <Box>
        <Typography variant="h4" component="h1" gutterBottom>
          {title}
        </Typography>
        <Alert severity="error">
          You do not have permission to view this page.
        </Alert>
      </Box>
    )
  }

  return <>{children}</>
}

export default AdminPageGate
